import { AUTH_ERROR_CODE, type AuthErrorCode } from "@/constants/auth-error"

export class AuthStageError extends Error {
  readonly code: AuthErrorCode

  constructor(code: AuthErrorCode, message: string) {
    super(message)
    this.name = "AuthStageError"
    this.code = code
  }
}

export function normalizeAccessToken(token: unknown): string | null {
  if (typeof token !== "string") return null

  const trimmed = token.trim()
  if (!trimmed || trimmed === "null" || trimmed === "undefined") {
    return null
  }

  return trimmed
}

export function requireAccessToken(token: unknown): string {
  const normalized = normalizeAccessToken(token)

  if (!normalized) {
    throw new AuthStageError(
      AUTH_ERROR_CODE.TOKEN_EMPTY,
      "Backend returned an empty access token"
    )
  }

  return normalized
}
